"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideMenu = void 0;
var React = __importStar(require("react"));
var types_1 = require("./types");
var Context_1 = require("./Context");
function SideMenu(props) {
    var ctx = React.useContext(Context_1.GlobalContext);
    // console.log('ctx', ctx)
    var handleSetSelectedPanel = ctx.handleSetSelectedPanel, selectedPanel = ctx.selectedPanel;
    return (React.createElement("div", null,
        React.createElement("div", { className: "side-menu text-center" },
            React.createElement("div", { className: "side-menu-item p-3 " + (selectedPanel === types_1.PanelNames.Scale ? "active" : ""), onClick: function () { return handleSetSelectedPanel(types_1.PanelNames.Scale); } },
                React.createElement("i", { className: "fas fa-expand-arrows-alt" }),
                React.createElement("div", { className: "small" }, "Scale")),
            React.createElement("div", { className: "side-menu-item p-3 " + (selectedPanel === types_1.PanelNames.Signature ? "active" : ""), onClick: function () { return handleSetSelectedPanel(types_1.PanelNames.Signature); } },
                React.createElement("i", { className: "fas fa-signature" }),
                React.createElement("div", { className: "small" }, "Signature")))));
}
exports.SideMenu = SideMenu;
